<!--
 * @Author: zjw
 * @Date: 2021-05-26 10:02:47
 * @LastEditTime: 2023-05-11 17:57:09
 * @FilePath: \web-app\src\components\content\mySearch.vue
 * @Environment: Vue + Element
 * @Description: 搜索组件
-->
<template>
    <div class="my-search">
        <el-form :inline="true" class="user-search" size="small">
            <!-- 时间筛选 -->
            <el-form-item v-if="timeScreen">
                <el-date-picker type="daterange" clearable start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" value-format="yyyy-MM-dd" v-model="searchParams.timeOptions" :picker-options="pickerOptions" @change="getdayTime">
                </el-date-picker>
            </el-form-item>

            <!-- 下拉筛选 -->
            <el-form-item v-show="selectArr.length != 0" v-for="(option, index) in selectArr" :key="index + Math.random()">
                <el-select v-model="searchParams[option.name]" :placeholder="option.defaultText ? option.defaultText : '请选择'" clearable>
                    <el-option v-for="item in option.defaultOptions" :key="item.value" :label="option.label?item[option.label]:item.label" :value="option.getData?item[option.getData]:item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <slot></slot>
            </el-form-item>
            <!-- 文本框筛选 -->
            <el-form-item v-show="inputArr.length != 0" v-for="(item, index) in inputArr" :key="index">
                <el-input clearable v-model.trim="searchParams[item.name]" :placeholder="item.defaultText" @keyup.enter.native="searchEvent"></el-input>
            </el-form-item>

            <!-- 搜索事件 -->
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="searchEvent"></el-button>
            </el-form-item>

        </el-form>

        <el-form :inline="true">
            <el-form-item v-if="buttonScreen">
                <el-button size="small" type="danger" icon="el-icon-delete" @click="allDel" v-if="order == 0 || order == 1|| order == 4">
                    批量删除
                </el-button>
                <el-button size="small" type="primary" icon="el-icon-zoom-in" @click="addEvent" v-if="order == 0 || order == 2|| order == 4">
                    添加
                </el-button>
            </el-form-item>
            <el-form-item style="float: right" v-if="order == 0 || order == 3">
                <!-- 导入组件 -->
                <my-import ref="refImport" />

                <el-button size="small" type="primary" plain round @click="allExport">
                    批量导出
                </el-button>

                <el-button size="small" type="primary" plain round @click="allImportTemplate">
                    导入模板
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    name: "mySearch",
    components: {
        myImport: () => import("@/components/content/myImport"),
    },
    data() {
        return {
            //禁止选今天以后的日期
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
        };
    },
    props: {
        /**
         * 搜索所需的双向绑定参数
         * @param {*} timeOptions  日期参数
         */
        searchParams: {
            type: Object,
            default: function () {
                return {};
            },
        },
        /**
         * 文本筛选
         * @param {*} name  与searchParams搜索参数一一对应，用于双向绑定
         * @param {*} defaultText  默认提示文字
         */
        inputArr: {
            type: Array,
            default: function () {
                return [];
            },
        },
        /**
         * 下拉框筛选
         * @param {*} name  与searchParams搜索参数一一对应，用于双向绑定
         * @param {*} getData  用于选择获取label还是获取value，自行选择
         * @param {*} defaultOptions  下拉默认选项
         */
        selectArr: {
            type: Array,
            default: function () {
                return [];
            },
        },
        // 控制时间筛选显示、隐藏
        timeScreen: {
            type: Boolean,
            default: false,
        },
        // 控制按钮显示
        buttonScreen: {
            type: Boolean,
            default: false,
        },
        // 控制批量操作具体的显示数量，0默认显示全部
        order: {
            type: Number,
            default: 1,
        },
        /**
         * props自定义有验证规则
         * 返回值为false则验证不通过，报错
         */
        nums: {
            default: 2,
            validator: function (val) {
                return val > 1 && val < 100;
            },
        },
    },
    created() { },
    methods: {
        //搜索事件
        searchEvent() {
            this.$emit("searchEvent");
        },
        // 添加事件
        addEvent() {
            this.$emit("addEvent");
        },
        //批量删除事件
        allDel() {
            this.$emit("allDel");
        },
        //批量导出事件
        allExport() {
            this.$emit("allExport");
        },
        //导入模板事件
        allImportTemplate() {
            this.$emit("allImportTemplate");
        },
        getdayTime() {
            let timeOptions = this.searchParams.timeOptions;
            if (timeOptions != null) {
                timeOptions[0] = timeOptions[0] + " 00:00:00";
                timeOptions[1] = timeOptions[1] + " 23:59:59";
            } else {
                timeOptions = ['', '']
            }
            this.$emit("searchTime", timeOptions);
        },
    },
};
</script>

<style lang="scss" scoped>
.el-form-item {
    margin-bottom: 11px;
}
.upload {
    float: left;
    margin: 0 10px;
}
</style>
